import apiClient from './client'
import type { Suggestion, CreateSuggestionInput } from '@brent/shared/types'

export interface UpdateSuggestionInput {
  composer?: string
  title?: string
  composer_wikidata_id?: string | null
  work_wikidata_id?: string | null
  comment?: string | null
}

export const userSuggestionsApi = {
  create: (username: string, data: CreateSuggestionInput) =>
    apiClient.post<Suggestion>(`/admin/users/${username}/suggestions`, data),

  update: (username: string, suggestionId: string, data: UpdateSuggestionInput) =>
    apiClient.put<Suggestion>(`/admin/users/${username}/suggestions/${suggestionId}`, data),

  delete: (username: string, suggestionId: string) =>
    apiClient.delete<void>(`/admin/users/${username}/suggestions/${suggestionId}`),
}
